var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22611 3.39132C6.88579 3.74465 5.01412 5.67753 4.7327 8.16177L4.44531 10.6988C4.37389 11.3292 4.11839 11.9225 3.71258 12.4001C2.85141 13.4137 3.55035 15.0001 4.85812 15.0001H15.1412C16.449 15.0001 17.1479 13.4137 16.2868 12.4001C15.881 11.9225 15.6255 11.3292 15.554 10.6988L15.3641 9.02236M12.4997 16.6667C12.1358 17.6377 11.1539 18.3334 9.99967 18.3334C8.84548 18.3334 7.86358 17.6377 7.49967 16.6667M16.6663 4.16675C16.6663 5.54746 15.5471 6.66675 14.1663 6.66675C12.7856 6.66675 11.6663 5.54746 11.6663 4.16675C11.6663 2.78604 12.7856 1.66675 14.1663 1.66675C15.5471 1.66675 16.6663 2.78604 16.6663 4.16675Z",
    stroke: "#0B1230",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.82c60488e67e4f6dfee833dc8aa36a9e.svg";
export { ForwardRef as ReactComponent };